// extracted by mini-css-extract-plugin
export var addButton = "_p2-0";
export var border = "_p2-8";
export var check = "_p2-h";
export var danger = "_p2-6";
export var dropdownContainer = "_p2-1";
export var editModalBody = "_p2-j";
export var footerContainer = "_p2-i";
export var fullWidth = "_p2-a";
export var hide = "_p2-9";
export var icon = "_p2-3";
export var input = "_p2-7";
export var inputFlex = "_p2-b";
export var inputWrapper = "_p2-c";
export var manualFocus = "_p2-5";
export var optionButton = "_p2-4";
export var pillWrapper = "_p2-e";
export var pointer = "_p2-2";
export var showOverflow = "_p2-f";
export var tagsFlex = "_p2-d";
export var xButton = "_p2-g";